import React, { useEffect, useState } from 'react';
import { Pagination } from 'antd';
import { AccountTransactionFlowFilterInitialValue } from './config/filterOptions';
import { AccountTransactionFlowColumns } from "./components/AccountTransactionFlowColumns";
import { useAccountTransactionFlowQuery } from "./hooks/useAccountTransactionFlowQuery";
import AccountTransactionFlowFilter from "./components/AccountTransactionFlowFilter";

const AccountTransactionFlowPage: React.FC = () => {

    const [tempFilters, setTempFilters] = useState(AccountTransactionFlowFilterInitialValue());
    const [filters, setFilters] = useState(AccountTransactionFlowFilterInitialValue());
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    // 使用自定义hook获取数据
    const {
        accountTransactionFlowData,
        loading,
        refetch,
        totalElements,
        buildQueryVariables
    } = useAccountTransactionFlowQuery(filters, currentPage, pageSize);

    const handleResetFilters = () => {
        setTempFilters(AccountTransactionFlowFilterInitialValue());
        setFilters(AccountTransactionFlowFilterInitialValue());
    };

    const handleFilter = () => {
        setFilters(tempFilters);
        setCurrentPage(1);
    };

    // 添加useEffect监听状态变化后执行查询
    useEffect(() => {
        refetch(buildQueryVariables());
    }, [filters, currentPage, pageSize]);

    // 处理分页变化
    const handlePageChange = (page: number, pageSize: number) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    return (
        <div className="bg-white rounded-lg shadow-sm p-6">
            {/* 筛选条件 */}
            <AccountTransactionFlowFilter
                filters={tempFilters}
                setFilters={setTempFilters}
                handleFilter={handleFilter}
                handleResetFilters={handleResetFilters}
            />

            {/* 账户交易流水列表 */}
            <AccountTransactionFlowColumns
                rowData={accountTransactionFlowData}
                loading={loading}
            />

            {/* 分页 */}
            <div className="flex justify-between items-center">
                <div className="text-gray-500">{totalElements} results</div>
                <Pagination
                    current={currentPage}
                    total={totalElements}
                    pageSize={pageSize}
                    size="small"
                    showSizeChanger
                    onChange={handlePageChange}
                />
            </div>
        </div>
    );
};

export default AccountTransactionFlowPage;
